"use client"

import NextLink from "next/link"
import { usePathname } from "next/navigation"
import { useTranslation } from "react-i18next"
import { ComponentProps, FC } from "react"

type Props = ComponentProps<typeof NextLink>

const Link: FC<Props> = (props) => {
  const pathname = usePathname()
  const { i18n } = useTranslation()

  let _href = (props.href as string) || ""
  // Prefer i18n language (synced from server lang) over pathname — pathname may strip /vi|/en on SSR.
  const langFromPath = pathname.startsWith("/en") ? "en" : pathname.startsWith("/vi") ? "vi" : ""
  const lang = langFromPath || (i18n.language === "en" ? "en" : "vi")

  if (!_href.startsWith("/vi") && !_href.startsWith("/en") && !_href.startsWith("http")) {
    _href = `/${lang}${_href.startsWith("/") ? _href : `/${_href}`}`
  }

  return (
    <NextLink {...props} href={_href} />
  )
}

export default Link
